module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0052.jpg?v=57b42189";